export default{name:"plusbtn",props:["isClose"],methods:{emitOnClick:function emitOnClick(){this.$emit("click")}},computed:{compIsClose:function compIsClose(){return this.isClose}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/PlusBtn.vue
// module id = 264
// module chunks = 0